(() => {
  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-teaed-nav]').forEach((navigation) => {
      if (navigation.dataset.teaedReady === 'true') return;

      const links = Array.from(navigation.querySelectorAll('[data-teaed-topic-link]'));
      if (!links.length) return;

      const setActive = (activeLink) => {
        links.forEach((link) => {
          const isActive = link === activeLink;
          link.classList.toggle('is-active', isActive);
          if (isActive) {
            link.setAttribute('aria-current', 'location');
          } else {
            link.removeAttribute('aria-current');
          }
        });
      };

      const activateFromHash = () => {
        if (!window.location.hash) return;
        const matchingLink = links.find((link) => link.hash === window.location.hash);
        if (matchingLink) setActive(matchingLink);
      };

      links.forEach((link) => {
        link.addEventListener('click', () => setActive(link));
      });

      navigation.dataset.teaedReady = 'true';
      window.addEventListener('hashchange', activateFromHash);
      activateFromHash();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise());
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
